import { render, staticRenderFns } from "./TgGameVideo.vue?vue&type=template&id=7670b94a&"
import script from "./TgGameVideo.vue?vue&type=script&lang=js&"
export * from "./TgGameVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports